import React from "react";
import { NextButton } from "../../components/NextButton/NextButton";
import RightImg from "./assets/BG.png";
import { Icon } from "@iconify/react";
interface skillProp {
  iconName: string;
  text: string;
}
const Skill: React.FC<skillProp> = ({ iconName, text }) => (
  <p className="flex flex-col items-center font-nunito font-medium tracking-wide gap-2">
    <Icon icon={iconName} fontSize={30} />
    <span className=" text-sm font-semibold text-gray-300 ">{text}</span>
  </p>
);

const SKILLS_CONTENT = [
  // {
  //   label: "Project Development",
  //   content: "Experienced in building full-stack applications from the ground up, implementing real-time features, and optimizing performance to deliver seamless user experiences."
  // },
  {
    label: "Frontend Development",
    content:
      "Proficient in crafting responsive, user-centric interfaces using ReactJS, Next.js, and Tailwind CSS. Skilled at managing complex UI states and handling dynamic user interactions with efficiency.",
  },
  {
    label: "Backend Development",
    content:
      "Expert in developing scalable, secure, and maintainable backends using Node.js, NestJS, and MongoDB. Strong foundation in designing RESTful APIs and integrating databases for robust data flow.",
  },
  {
    label: "TypeScript Expertise",
    content:
      "Deep experience with TypeScript, ensuring type safety, better tooling, and long-term maintainability across both frontend and backend codebases.",
  },
  {
    label: "AI & Chatbot Development",
    content:
      "Specialized in building AI-powered chatbots with OpenAI, capable of delivering dynamic, context-aware responses based on real-time and static data integration.",
  },
  {
    label: "Data Integration & Analytics",
    content:
      "Skilled in implementing Google Analytics and Google Tag Manager for performance monitoring, event tracking, and making informed, data-driven decisions.",
  },
];
const SkillTexts = ({ label, content }: { label: string; content: string }) => (
  <div className="flex flex-col text-base gap-4">
    <p className="text-primary-500 font-manrope font-[600] xl:text-lg">
      👩‍💻 {label}
    </p>{" "}
    <p className="text-justify xl:text-xl">{content}</p>
  </div>
);
export const SkillsContent: React.FC = () => {
  return (
    <div
      className={
        " block lg:flex gap-4 items-center text-[#f7f7f7] relative py-[10rem] md:pt-[20rem] md:pb-[10rem] px-[10%] min-h-screen font-nunito  "
      }
    >
      <div
        className={
          "bg-dark-500  py-[4rem] md:py-[6rem] px-[5%] max-w-[1000px] mx-auto border-[1px] border-solid  rounded-lg border-white/10 shadow-lg shadow-white/10"
        }
      >
        {/* text part */}
        <h1 className="text-xl md:text-2xl tracking-wide font-nunito font-semibold text-primary-500 mb-10 text-center">
          Things I do{" "}
        </h1>
        <div className="flex flex-col gap-10">
          {SKILLS_CONTENT.map((skill) => (
            <SkillTexts
              key={skill.label}
              label={skill.label}
              content={skill.content}
            />
          ))}
        </div>
        <div className="flex flex-row flex-wrap gap-[4rem] justify-center mt-[100px]">
          <Skill iconName="material-icon-theme:nest" text="Nest JS" />
          <Skill iconName="vscode-icons:file-type-reactts" text="React" />
          <Skill iconName="vscode-icons:file-type-scss2" text="SCSS" />

          <Skill iconName="simple-icons:express" text="Express" />

          <Skill iconName="vscode-icons:file-type-mongo" text="MongoDB" />
          <Skill iconName="logos:nodejs" text="Nodejs" />
          <Skill
            iconName="vscode-icons:file-type-typescript-official"
            text="Typescript"
          />
          <Skill iconName="vscode-icons:file-type-git" text="Git" />
        </div>
      </div>
      {/* <div className={""}>
        {/* img part 
        <div className="clip-zigzag">
          <img src={RightImg} alt="Skills" className="w-full h-auto object-cover grayscale-[120%]"/>
        </div>
      </div> */}

      <NextButton nextRoute="/projects" />
    </div>
  );
};
